import { Injectable } from "@angular/core";
import { Observable, of, Subject, BehaviorSubject } from "rxjs";
import { RestService } from "@recore-solutions/nstar-lib";
import { environment } from "../../environments/environment";
import { switchMap } from "rxjs/operators";

@Injectable({
	providedIn: "root",
})
export class HelpService {
	private helpRequestSubj: Subject<{ module: string; page: string }> = new BehaviorSubject(null);
	private get helpEndpoint(): string {
		return environment.endpoints.help;
	}

	help$: Observable<any>;

	constructor(private rest: RestService) {
		this.help$ = this.helpRequestSubj
			.asObservable()
			.pipe(switchMap((request) => (!!request ? this.getHelp(request) : of(null))));
	}

	showHelp({ module, page }: { module: string; page: string }): void {
		this.helpRequestSubj.next({ module, page });
	}

	closeHelp(): void {
		this.helpRequestSubj.next(null);
	}

	getHelp({ module, page }: { module: string; page: string }): Observable<any> {
		return this.helpEndpoint ? this.rest.get<any>([this.helpEndpoint, module, page]) : of(null);
	}
}
